
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b4VFP", function(module, exports) {

$parcel$export(module.exports, "HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS", () => $390e454b1ae488b2$export$1d1c13df264a094);
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = [
    ...Object.values($390e454b1ae488b2$export$1d1c13df264a094)
];

});

parcelRegister("aDe4X", function(module, exports) {

$parcel$export(module.exports, "useNthUserHomeOnboardingTakeoverV2Eligibility", () => $d12c0291e106b88f$export$de7bc1ba49cd35c5);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $jn4Wd = parcelRequire("jn4Wd");
var $9KHdj = parcelRequire("9KHdj");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $euL71 = parcelRequire("euL71");

var $ivb8S = parcelRequire("ivb8S");

var $b4VFP = parcelRequire("b4VFP");
var $dBcar = parcelRequire("dBcar");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $1wZpa = parcelRequire("1wZpa");

var $2FNNv = parcelRequire("2FNNv");

var $9wGTI = parcelRequire("9wGTI");
const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$var$HTV2PersonalizationQuery = (0, $d2LG0.default)`query useNthUserHomeOnboardingTakeoverV2EligibilityUserPersonalizationQuery($userId:String!)@experimental{experimentalUserPersonalization(userId:$userId){attributes{name value}}}`;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId, edition: edition, locale: locale } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // User joins a paid editions and has locale as english
    const isEligibleForExperiment = edition !== (0, $euL71.ConfluenceEdition).FREE && (0, $1wZpa.isLocaleEnglish)(locale);
    (0, $gwFzn.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess || !isEligibleForExperiment || !(0, $9wGTI.fg)('cc_onboarding_nth_user_home_takeover_gate'));
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $9KHdj.default)(Date.now(), (0, $jn4Wd.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $j1Ss3.useQuery)($d12c0291e106b88f$var$HTV2PersonalizationQuery, {
        skip: !hasAdminOrUseAccess || !isEligibleForExperiment || takeoverExpired || !(0, $9wGTI.fg)('cc_onboarding_nth_user_home_takeover_gate'),
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && isEligibleForExperiment && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin && (0, $9wGTI.fg)('cc_onboarding_nth_user_home_takeover_gate'));
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};

});
parcelRegister("1wZpa", function(module, exports) {

$parcel$export(module.exports, "isLocaleEnglish", () => $ea6df990daadbbff$export$68fe00948fce4bd0);
/**
 * Checks if the specified locale and the browser's language setting are English.
 * Optionally skips the browser's language check.
 *
 * @param {string} locale - The locale to check. It will be transformed to lowercase for comparison.
 * @param {boolean} [skipBrowserCheck=false] - Whether to skip checking the browser's language setting. Defaults to false.
 * @returns {boolean} - Returns true if:
 *  - The passed locale starts with 'en' and navigator language setting starts with 'en'.
 *  - The passed locale starts with 'en' and either skipBrowserCheck is true or the navigator object is not available.
 * Returns false otherwise.
 */ const $ea6df990daadbbff$export$68fe00948fce4bd0 = (locale, skipBrowserCheck = false)=>{
    const englishPrefix = 'en';
    const isLocaleEnglish = locale.toLowerCase().startsWith(englishPrefix);
    // When skipBrowserCheck is true or we are not in a browser environment, only check locale
    if (skipBrowserCheck || !Boolean(window?.navigator)) return isLocaleEnglish;
    // Otherwise, check both locale and navigator language
    return isLocaleEnglish && navigator.language?.toLowerCase().startsWith(englishPrefix);
};

});



//# sourceMappingURL=OnboardingStateEditor.23cd70bb.js.map
